export {SimpleRating} from './SimpleRating';
